import React, { useState, useContext, useEffect } from 'react';  
import { Avatar, CssBaseline, Box, Grid, Paper } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { AuthContext } from 'core/context';
import Register from './Register';
import { useLocation } from 'react-router-dom';
import SignIn from './SignIn';
// import Copyright from 'components/CopyRight';



export default function SignInSide() {
  /* Hooks */
  const [toggleSignIn, setToggleSignIn] = useState(true);
  let navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const location = useLocation()

  
  useEffect(() => {
    if(authContext?.isUserLoggedIn){
      navigate('/overview/', {replace: true})
    }else{
      setToggleSignIn( location.pathname.indexOf('/signin/') > -1 ? true : false);
    }
  }, [authContext, navigate, location]);


  return (

    <Grid container component="main" justifyContent="center" alignItems='center'
      sx={{ 
        height: '100vh',
        backgroundImage: `url(${process.env.REACT_APP_PATH}/assets/images/hp_banner.jpg)`,
        backgroundPosition: 'center', 
        backgroundSize: 'cover',
        pb: '51px'
      }}
    >
      <CssBaseline />

      <Grid item container sm={12} md={12} lg={12} 
      //  sx={{ flexDirection: 'column'}}
      >
      {/* <Box 
        sx={{
          backgroundImage: `url(${process.env.REACT_APP_PATH}/assets/images/login-banner.jpg)`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          width: '98vw',
          position: 'absolute',
          height: '100vh',
          opacity: '0.7',
          pb: '51px'
        }}
        /> */}
        <Grid item sm={12} md={12} lg={12} sx={{ position: 'absolute', height:'100vh', display: { sm: 'none', xs: 'none', md: 'block', lg: 'block' } }}>  
          <Box
            sx={{
              // py: 8,
              // px: 4,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              height:'100vh',
              justifyContent: 'center',
              position: 'relative'
            }}
            >
            {/* <Typography component="h2" variant="h3" color="primary.dark" sx={{ padding: 1, borderBottom: '8px solid #F8C907'}}>
              Webook Admin
            </Typography> */}
          </Box>
        </Grid> 
        <Grid  item xs={12} sm={12} md={6} lg={4} component={Paper} elevation={6} square 
          sx={{ position: 'relative', pb: '54px', margin: '0 auto'}}
        >
          <Grid container item xs={12} sm={12} md={12} lg={12}  sx={{dislay:'flex', flexDirection:'column', alignItems: "center" }}>
            <Grid  item xs={12} sm={12} md={6} lg={12}>
              <Avatar
                sx={{ mt: 4, mb: 2,  width: 120, height: 60}}
                alt="Webook Logo" src={`${process.env.REACT_APP_PATH}/assets/images/webook_logo_large.png`}
                className='login-logo'
              />
            </Grid>
          </Grid>

          {toggleSignIn ? <SignIn /> : <Register />}
        </Grid>
      </Grid>
      {/* <Grid
        item
        sm={12}
        md={12}
        lg={12}
        sx={{  position: 'fixed', width: '100%', height: '51px',bottom: 0, zIndex: 100, borderTop: '1px solid #f5f4f4'}}
      > */}
      {/* </Grid> */}
    </Grid>
  );
}
